import { ApplicationState, resetAllStores } from "../../store";
import { getErrorObject } from "../../store/Errors/selectors";
import { getIsUserAuthenticated } from "../../store/Login/selectors";
import { getClinicName } from "../../store/ClinicInformation/selectors";
import { getEnterFunction } from "../../store/Keyboard/selectors";

import { Routes } from "../../constants/routes";
import { closeErrorPopup } from "../../store/Errors/actions";
import {
    toggleKeyboardDisableValue,
    disconnectKeyboard,
    pressedKeyboardButton
} from "../../store/Keyboard/actions";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Main } from "./Main.component";
import {
    getLanguageResourceGeneralStrings
} from "../../store/LanguageLocale/selector";
import { push } from "../../store/Routing/actions";
import { clearDebugMessageList } from "../../store/Utilities/actions";

const mapStateToProps = (state: ApplicationState) => {
    return {
        currentRoute: state.routing.currentRoute,
        localeString: getLanguageResourceGeneralStrings(state.localeText),
        error: getErrorObject(state.errors),
        isUserAuthenticated: getIsUserAuthenticated(state.login),
        clinicSiteName: getClinicName(state.clinicInformation),
        pipe: state.keyboard.pipe,
        currentInputValue: state.keyboard.value,
        showKeyboard: state.keyboard.showKeyboard,
        isKeyboardDisabled: state.keyboard.isDisabled,
        enterFunction: getEnterFunction(state.keyboard),
        keyboardType: state.keyboard.keyboardType,
        showLanguageSelection: state.localeText.showLanguageSelection,
        debugMessages: state.utilities.messages,
        enableDebugWindowFeature: state.clinicInformation.featureFlags.debugWindowModeEnabled
    };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    cleanAndReturn: () => {
        dispatch(resetAllStores());
        dispatch(push(Routes.introduction));
        dispatch(closeErrorPopup());
    },
    returnToLoginPage: () => {
        dispatch(push(Routes.root));
    },
    closeErrorPopup: () => {
        dispatch(closeErrorPopup());
    },
    toggleKeyboardDisableValue: () => {
        dispatch(toggleKeyboardDisableValue());
    },
    hideKeyboard: () => {
        dispatch(disconnectKeyboard());
    },
    onKeyboardChangeValue: (value: string) => {
        dispatch(pressedKeyboardButton(value));
    },
    onClearDebugMessages: () => {
        dispatch(clearDebugMessageList())
    }
});

type MainMapStateProps = ReturnType<typeof mapStateToProps>;
type MainMapDispatchProps = ReturnType<typeof mapDispatchToProps>;
export type IMainProps = MainMapStateProps & MainMapDispatchProps;
export default connect<MainMapStateProps, MainMapDispatchProps, void>(mapStateToProps, mapDispatchToProps)(Main);


// WEBPACK FOOTER //
// ./src/components/Main/Main.container.ts